import * as React from "react";
import { PuffLoader } from "react-spinners";
import Backdrop from '@mui/material/Backdrop';
export default function RingLoaderShared () {
    return (
      <div>
      <Backdrop
       sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1,backgroundColor: 'rgba(255, 255, 255, 0.5)',position: 'absolute'  }}
      open={true}
    >
          <PuffLoader 
            color={"#5800e2"}
            loading={true}
            size={100}
            speedMultiplier={1}
          />
      
        </Backdrop>
        </div>
    );
}